import { icon } from "../functions/icons";

export function PackageComp({packageData, active,onClick}){
    return(
        <div onClick={onClick} className={`vertical space-between standard-padding standard-border standard-rounded lesson-comp billing-content ${active&&'primary-background-50'}`} style={{width:"unset", height:"unset"}}>
        <div className="horizontal space-between">
            <p className={`small-text bold-text grey-900`}>{packageData.Package}</p><input className='checkbox-input' type="checkbox" checked={active}/>
        </div>
        <h4 className="standard-margin-top standard-margin-bottom">{packageData.Price}/maand</h4>
        <div className="horizontal">{icon('check')}<p className="light-bold">{packageData.CourseCount} aantal cursussen</p></div>
        <div className="horizontal">{icon('check')}<p className="light-bold">{packageData.EmployeeCount} aantal werknemers</p></div>
        <div className="horizontal">{icon('cross')}<p className="light-bold">{packageData.Support}</p></div>
    </div>
    )
}